import { Pipe, PipeTransform } from '@angular/core';
import {
  AccountMoveLightModel,
  AccountMoveModel,
  AccountMoveTabDetailModel,
} from '../../store/accounting/types';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'showPaymentAndTruncate',
  standalone: false,
})
export class ShowPaymentAndTruncatePipe implements PipeTransform {
  constructor(private readonly currencyPipe: CurrencyPipe) {}

  transform(
    values:
      | AccountMoveTabDetailModel[]
      | AccountMoveModel[]
      | AccountMoveLightModel[],
    ...args: any[]
  ): string {
    const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
    const trail = args.length > 1 ? args[1] : '...';

    let payments = '';

    if (values.length === 0) return '';

    for (let i = 0; i < values.length; i++) {
      const accountMove = values[i];

      if (!accountMove) continue;

      for (
        let index = 0;
        index < accountMove.accountMoveLines.length;
        index++
      ) {
        const accountMoveLine = accountMove.accountMoveLines[index];

        if (!accountMoveLine) continue;

        payments += `${
          accountMoveLine.paymentModeShortNameLoc
        } (${this.currencyPipe.transform(accountMoveLine.unitPriceClientView, 'EUR')})`;

        if (
          i != values.length - 1 ||
          index != accountMove.accountMoveLines.length - 1
        ) {
          payments += ', ';
        }
      }
    }

    return payments.length > limit
      ? payments.substring(0, limit) + ' ' + trail
      : payments;
  }
}
